import React, { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { COMPANY } from "../lib/constants";

/**
 * Floating call-to-action.
 * - Strong shadow for visibility against any background.
 * - Auto-hides when the footer or quote form button is visible, so it never
 *   covers other clickable elements.
 */
export const WhatsAppFloat = () => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const checkOverlap = () => {
      // Hide near footer or on top of the main quote-form submit button.
      const footer = document.querySelector("footer");
      const submit = document.querySelector("[data-testid='quote-submit-btn']");
      const chatPanel = document.querySelector("[data-testid='chat-widget-panel']");
      const viewportH = window.innerHeight;

      const intersects = (el) => {
        if (!el) return false;
        const r = el.getBoundingClientRect();
        return r.top < viewportH && r.bottom > viewportH - 120;
      };

      setHidden(intersects(footer) || intersects(submit) || !!chatPanel);
    };

    checkOverlap();
    window.addEventListener("scroll", checkOverlap, { passive: true });
    window.addEventListener("resize", checkOverlap);
    // Also observe DOM changes so we react instantly when chat opens/closes.
    const mo = new MutationObserver(checkOverlap);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => {
      window.removeEventListener("scroll", checkOverlap);
      window.removeEventListener("resize", checkOverlap);
      mo.disconnect();
    };
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-6 z-40 transition-all duration-300 ${
        hidden ? "opacity-0 translate-y-4 pointer-events-none" : "opacity-100 translate-y-0"
      }`}
    >
      <a
        data-testid="phone-float-btn"
        href={COMPANY.landlineHref}
        aria-label={`Ligar para ${COMPANY.landline}`}
        title={`Ligar para o fixo ${COMPANY.landline}`}
        className="w-14 h-14 md:w-16 md:h-16 bg-[#FF5A00] hover:bg-[#E65100] flex items-center justify-center pulse-ring transition-colors rounded-full"
        style={{
          boxShadow:
            "0 10px 25px rgba(0, 0, 0, 0.55), 0 0 0 3px rgba(255, 255, 255, 0.08), 0 8px 24px rgba(255, 90, 0, 0.45)",
        }}
      >
        <Phone className="w-6 h-6 md:w-7 md:h-7 text-white" strokeWidth={2.2} />
      </a>
    </div>
  );
};

export default WhatsAppFloat;
